import * as dates from '@simplybenefits/sb-dates';
import validateInput from "../../../services/FormValidation/validateInput.js";
import i18n from "../../../localization/i18n.js";
import tokens from "../../../localization/tokens.js";

/**
 * 
 * @returns 
 */
const validateSignage = async ({
  password,
  name,
  signature,
  datedOn,
  acceptedTerms
}) => {
  const errors = {}; // Object to store validation errors

  errors.passwordError = await validateInput('checkEmpty', password);
  errors.signageNameError = await validateInput('checkEmpty', name);
  errors.signageSignatureError = await validateInput('checkEmpty', signature);
  errors.signageDatedOnError = await validateInput('date', datedOn, i18n.locale);
  errors.signageAcceptedError = !acceptedTerms;
  if (errors.signageAcceptedError) {
    alert(i18n.t(tokens.labels.signage.pleaseAcceptAndAcknowledgeChanges));
    return null;
  }
  if (name !== signature) {
    errors.signageNameError = i18n.t(tokens.labels.signage.signageNameError);
  }

  // Check for any errors
  const hasErrors = Object.values(errors).some(Boolean);
  return hasErrors ? errors : false;
};
export default validateSignage;